{
  "tabs": {
    "chat": "المحادثة",
    "reminders": "التذكيرات",
    "calendar": "التقويم",
    "settings": "الإعدادات"
  },
  "common": {
    "cancel": "إلغاء",
    "save": "حفظ",
    "confirm": "تأكيد",
    "delete": "حذف",
    "back": "رجوع",
    "close": "إغلاق",
    "edit": "تعديل",
    "search": "بحث",
    "all": "الكل",
    "loading": "جاري التحميل...",
    "error": "حدث خطأ",
    "notFound": "غير موجود",
    "tryAgain": "يرجى المحاولة مرة أخرى",
    "retry": "إعادة المحاولة",
    "undo": "تراجع",
    "pullToRefresh": "اسحب للتحديث",
    "justNow": "الآن"
  },
  "auth": {
    "welcome": "مرحباً بك في FishMemory",
    "tagline": "مساعد تذكيرات واتساب، الآن في جيبك.",
    "subtitle": "مساعد تذكيرات واتساب، الآن في جيبك.",
    "phoneLabel": "رقم واتساب",
    "phoneHint": "سنرسل رمز التحقق عبر واتساب",
    "invalidPhone": "يرجى إدخال رقم هاتف صحيح",
    "continue": "متابعة",
    "enterPhone": "أدخل رقم واتساب",
    "phonePlaceholder": "رقم الهاتف",
    "sendCode": "إرسال الرمز",
    "verifyTitle": "تحقق من الرقم",
    "otpSentTo": "تم إرسال رمز مكون من 6 أرقام إلى {{phone}} عبر واتساب",
    "enterFullCode": "يرجى إدخال الأرقام الستة كلها",
    "invalidOtp": "الرمز غير صحيح. حاول مرة أخرى.",
    "otpFailed": "فشل إرسال الرمز. حاول مرة أخرى.",
    "otpResent": "تمت إعادة الإرسال",
    "resendIn": "إعادة الإرسال خلال {{seconds}} ثانية",
    "resendCode": "إعادة إرسال الرمز",
    "enterOtp": "أدخل الرمز المرسل إلى واتساب",
    "verify": "تحقق",
    "resend": "إعادة إرسال الرمز",
    "wrongNumber": "رقم خاطئ؟",
    "backToPhone": "العودة إلى الرقم",
    "editPhone": "تعديل رقم الهاتف",
    "error": "خطأ",
    "setupTitle": "لنكمل الإعداد",
    "setupSubtitle": "يمكنك تغيير هذه الإعدادات لاحقاً من الإعدادات",
    "namePlaceholder": "اسمك",
    "letsGo": "إنهاء الإعداد",
    "skipForNow": "تخطي الآن"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "اكتب رسالة...",
    "inputPlaceholder": "اكتب رسالة...",
    "typing": "FishMemory يكتب...",
    "online": "متصل",
    "connecting": "جارٍ الاتصال...",
    "reconnecting": "إعادة الاتصال...",
    "offline": "غير متصل",
    "empty": "ابدأ المحادثة",
    "emptyHint": "أنشئ تذكيراً أو اسأل عن جدولك أو اطلب المساعدة.",
    "emptyAction": "إرسال تذكير تجريبي",
    "actions": "إجراءات المحادثة",
    "keep": "الاحتفاظ بالرسائل",
    "clearTitle": "مسح المحادثة",
    "clearConfirm": "حذف كل الرسائل من هذا الجهاز؟ لا يمكن التراجع.",
    "clear": "مسح المحادثة",
    "optionSelected": "تم الاختيار: {{label}}",
    "sendingSelection": "جارٍ الإرسال...",
    "connectionLost": "جارٍ إعادة الاتصال..."
  },
  "reminders": {
    "title": "تذكيراتي",
    "active": "النشطة",
    "today": "اليوم",
    "thisWeek": "هذا الأسبوع",
    "history": "السجل",
    "items": "عناصر",
    "emptyTitle": "لا توجد تذكيرات بعد",
    "emptySubtitle": "أنشئ تذكيراً من المحادثة وسيظهر هنا.",
    "emptyAction": "فتح المحادثة",
    "filterActive": "النشطة",
    "filterToday": "اليوم",
    "filterWeek": "هذا الأسبوع",
    "filterHistory": "السجل",
    "emptyState": "لا توجد تذكيرات بعد. ابدأ بالمحادثة!",
    "swipeDone": "تم",
    "swipeSnooze": "تأجيل",
    "swipeDelete": "حذف",
    "search": "بحث في التذكيرات...",
    "upcoming": "القادمة",
    "completed": "المكتملة",
    "overdue": "متأخرة",
    "tomorrow": "غداً",
    "synced": "تمت المزامنة {{value}}",
    "swipeHint": "اسحب التذكير لمزيد من الإجراءات",
    "showAllCount": "عرض الكل ({{count}})",
    "showFewer": "عرض أقل",
    "noResults": "لا توجد تذكيرات تطابق بحثك",
    "noResultsHint": "جرب كلمة مفتاحية مختلفة أو امسح البحث",
    "deleteAllFailed": "فشل حذف كل التذكيرات"
  },
  "calendar": {
    "title": "التقويم",
    "today": "اليوم",
    "tomorrow": "غداً",
    "completed": "تم",
    "noEvents": "لا يوجد شيء مجدول",
    "noEventsSubtitle": "اختر تاريخاً لرؤية التذكيرات والأحداث.",
    "googleEvent": "تقويم Google",
    "legendActive": "نشط",
    "legendRecurring": "متكرر",
    "legendDone": "تم",
    "legendGoogle": "Google",
    "previousMonth": "الشهر السابق",
    "nextMonth": "الشهر التالي",
    "previousYear": "السنة السابقة",
    "nextYear": "السنة التالية",
    "goToToday": "العودة إلى اليوم",
    "all": "الكل",
    "active": "نشط",
    "done": "تم",
    "paused": "موقوف"
  },
  "settings": {
    "title": "الإعدادات",
    "profile": "الملف الشخصي",
    "name": "الاسم الظاهر",
    "enterName": "أدخل اسمك",
    "language": "اللغة",
    "uiLanguage": "لغة التطبيق",
    "uiLanguageHelp": "تغيّر واجهة التطبيق وتسميات التقويم واتجاه العرض على هذا الجهاز فقط.",
    "serverLanguage": "لغة المحادثة",
    "serverLanguageHelp": "تغيّر اللغة التي يستخدمها الخادم في الردود ورسائل التذكير لحسابك.",
    "timezone": "المنطقة الزمنية",
    "currentTimezone": "المنطقة الزمنية الحالية",
    "timezoneHelp": "سيتم عرض أوقات التذكيرات وفق هذه المنطقة الزمنية.",
    "timezonePlaceholder": "Asia/Beirut",
    "timezoneSave": "حفظ المنطقة الزمنية",
    "timezoneSaved": "تم تحديث المنطقة الزمنية",
    "detect": "كشف",
    "detectFailed": "تعذر تحديد المنطقة الزمنية",
    "autoDetect": "كشف تلقائي عبر GPS",
    "notifications": "الإشعارات",
    "notificationsHelp": "تتحكم تذكيرات المتابعة في التنبيهات المتكررة بعد إرسال التذكير. أما صلاحيات الإشعارات على مستوى الجهاز فتُدار من إعدادات الهاتف.",
    "pushEnabled": "إشعارات فورية",
    "autoDoneOnFire": "تحديد منجز تلقائياً عند الإطلاق",
    "autoDoneOnFireDesc": "عند الإيقاف، تبقى التذكيرات فعّالة حتى تحددها كمنجزة.",
    "googleCalendar": "تقويم Google",
    "google": "تقويم Google",
    "googleConnected": "متصل",
    "googleDisconnected": "غير متصل",
    "googleConnectedHelp": "يمكن مزامنة التذكيرات الجديدة مع التقويم تلقائياً.",
    "googleDisconnectedHelp": "اربط تقويم Google لمزامنة التذكيرات والأحداث.",
    "googleConnectFailed": "فشل ربط تقويم Google",
    "connected": "متصل",
    "disconnected": "غير متصل",
    "connect": "ربط",
    "disconnect": "فصل",
    "autoSync": "مزامنة التذكيرات الجديدة تلقائياً",
    "autosync": "مزامنة تلقائية",
    "subscription": "الاشتراك",
    "trialUsed": "تجريبي: {{used}}/{{total}} مستخدم",
    "trialStatus": "تجربة متاحة",
    "activeStatus": "اشتراك نشط",
    "expiredStatus": "انتهى الاشتراك",
    "unsubscribedStatus": "غير مشترك",
    "about": "حول",
    "version": "الإصدار",
    "logout": "تسجيل الخروج",
    "logoutTitle": "تسجيل الخروج",
    "logoutConfirm": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "noName": "لا يوجد اسم",
    "serverConnection": "اتصال الخادم",
    "serverUrl": "رابط الخادم",
    "serverEdit": "تعديل",
    "saveReconnect": "حفظ وإعادة الاتصال",
    "resetDefault": "استعادة الافتراضي",
    "invalidServerUrlTitle": "رابط خادم غير صالح",
    "invalidServerUrlMessage": "أدخل رابط http أو https صالحاً، مثل https://example.com",
    "uiLanguageChangeFailed": "فشل تغيير لغة التطبيق. حاول مرة أخرى.",
    "serverLanguageChangeFailed": "فشل تغيير لغة المحادثة. حاول مرة أخرى.",
    "timezoneChangeFailed": "فشل تغيير المنطقة الزمنية. حاول مرة أخرى.",
    "autoSyncChangeFailed": "فشل تحديث المزامنة التلقائية. حاول مرة أخرى.",
    "nameChangeFailed": "فشل تحديث الاسم. حاول مرة أخرى.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "تفاصيل التذكير",
    "editTime": "تعديل الوقت",
    "rename": "إعادة تسمية",
    "snooze": "تأجيل",
    "snooze15": "تأجيل 15 دقيقة",
    "pause": "إيقاف مؤقت",
    "pauseReminder": "إيقاف التذكير",
    "resume": "استئناف",
    "resumeReminder": "استئناف التذكير",
    "skip": "تخطي التالي",
    "skipOccurrence": "تخطي هذه المرة",
    "syncGoogle": "مزامنة مع Google",
    "delete": "حذف",
    "deleteTitle": "حذف التذكير",
    "deleteConfirm": "سيتم حذف هذا التذكير نهائياً.",
    "deleteRecurringTitle": "حذف تذكير متكرر",
    "deleteRecurringMessage": "هل تريد تخطي هذه المرة أو حذف السلسلة بالكامل؟",
    "deleteThisOccurrence": "تخطي هذه المرة",
    "deleteEntireSeries": "حذف السلسلة بالكامل",
    "done": "تم",
    "markDone": "وضع علامة تم",
    "undo": "إعادة التفعيل",
    "undoPrompt": "إذا أردته نشطاً مجدداً، يمكنك إعادة تفعيله الآن.",
    "recurring": "متكرر",
    "nextRun": "الموعد التالي",
    "oneTime": "مرة واحدة",
    "pending": "قيد الانتظار",
    "sent": "مرسل",
    "paused": "موقوف",
    "active": "نشط",
    "snoozed": "مؤجل",
    "localTime": "يتم العرض حسب وقت جهازك المحلي",
    "recurrence": "التكرار",
    "created": "تم الإنشاء",
    "tags": "الوسوم",
    "fireCount": "عدد مرات الإرسال",
    "actions": "الإجراءات",
    "none": "لا يوجد",
    "snoozeFailed": "فشل تأجيل التذكير",
    "pauseFailed": "فشل إيقاف التذكير",
    "resumeFailed": "فشل استئناف التذكير",
    "skipFailed": "فشل تخطي التذكير",
    "doneFailed": "فشل وضع علامة تم",
    "undoFailed": "فشلت إعادة تفعيل حالة التذكير",
    "deleteFailed": "فشل حذف التذكير",
    "rescheduleTitle": "إعادة جدولة؟",
    "rescheduleMsg": "هذا التذكير متأخر. هل تريد إعادة جدولته؟",
    "reschedule15": "بعد 15 دقيقة",
    "reschedule60": "بعد ساعة",
    "keepOverdue": "إبقاء كما هو"
  }
}
